import styled from 'styled-components';
import { colors } from '@keen.io/colors';
import { transparentize } from 'polished';
export var Label = styled.div.withConfig({
  displayName: "GeoCoordinatesstyles__Label",
  componentId: "keen-query-creator__sc-16sis3o-0"
})(["&&&{color:", ";}"], transparentize(0.5, colors.blue[500]));
export var Input = styled.input.withConfig({
  displayName: "GeoCoordinatesstyles__Input",
  componentId: "keen-query-creator__sc-16sis3o-1"
})(["&&&{outline:none;padding:0;border:none;background:transparent;color:", ";width:100%;-moz-appearance:textfield;}&&&::-webkit-outer-spin-button,&&&::-webkit-inner-spin-button{-webkit-appearance:none;}"], colors.blue[500]);
export var InputContainer = styled.div.withConfig({
  displayName: "GeoCoordinatesstyles__InputContainer",
  componentId: "keen-query-creator__sc-16sis3o-2"
})(["&&&{display:flex;padding:10px 14px;height:37px;width:100%;box-sizing:border-box;border:1px solid ", ";border-radius:4px;outline:none;font-size:14px;line-height:17px;font-family:'Lato Regular',sans-serif;}&&& ", " + ", "{margin-left:5px;}"], transparentize(0.5, colors.black[500]), Label, Input);
export var GeoItem = styled.div.withConfig({
  displayName: "GeoCoordinatesstyles__GeoItem",
  componentId: "keen-query-creator__sc-16sis3o-3"
})(["&&&{}"]);
export var Radius = styled.div.withConfig({
  displayName: "GeoCoordinatesstyles__Radius",
  componentId: "keen-query-creator__sc-16sis3o-4"
})(["&&&{max-width:120px;}"]);
export var Container = styled.div.withConfig({
  displayName: "GeoCoordinatesstyles__Container",
  componentId: "keen-query-creator__sc-16sis3o-5"
})(["&&&{display:flex;}&&& ", " + ", "{margin-left:5px;}"], GeoItem, GeoItem);